<template>
  <section class="about-project" @mousemove="shakeIt">
    <div class="about-project__wrapper">
      <MainPageAnimation />
      <div class="about-project__container">
        <div class="about-project__content">
          <BaseTitle class="about-project__title" :text="titleText" :tag="'h2'" />
          <BaseCaption class="about-project__caption" :text="captionCaption" />
          <BaseText class="about-project__descr" :text="descriptionText" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MainPageAnimation from '~/components/MainPageAnimation'
import HomeDoodleMixin from '~/mixins/HomeDoodle.js'

export default {
  name: 'AboutProjectBlock',
  computed: {
    titleText() {
      return this.messages.about.aboutProject.title
    },
    captionCaption() {
      return this.messages.about.aboutProject.caption
    },
    descriptionText() {
      return this.messages.about.aboutProject.description
    }
  },
  mixins: [HomeDoodleMixin],
  components: {
    MainPageAnimation
  }
}
</script>

<style lang="scss">
.about-project {
  &__wrapper {
    position: relative;
    padding: 60px 0 100px;

    .main-animation-background {
      margin: 0
    }
  }

  &__container {
    @include container;
  }

  &__content {
    padding: 0 16px;
  }

  &__title.title {
    margin: 0 0 30px;
    text-align: center;
  }

  &__caption {
    margin: 0;
    line-height: 21px;
  }

  &__descr {
    margin: 0;
  }
}

@include media-min($tablet-width) {
  .about-project {

    &__content {
      padding: 0 25px;
    }

    &__title {
      margin-bottom: 26px;
    }

    &__caption {
      margin-bottom: 8px;
    }
  }
}

@include media-min($desktop-width) {
  .about-project {
    &__wrapper {
      padding: 80px 0 150px;
    }

    &__content {
      padding: 0 60px;
    }

    &__title {
      margin-bottom: 26px;
    }

    &__caption {
      margin-bottom: 8px;
    }

    & a {
      position: relative;
      z-index: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/AboutProjectBlock.vue